import { Control } from "Controls/Control";
import { DisplayModes, CssClass } from "Enums";
import { ControlTemplate } from "Controls/Entities";

/**
 * @hidden
 */
export const TEXTBLOCKCONTROL_FUNC_PROPERTY_NAME: string = "__dms_textBlockControl_";

/**
 * Control for text input.
 * @since 4.0.0
 * @example
 * ```JavaScript
 * // Access the instance of an TextBlockControl with ControlID 1337
 * // In script:
 * @@ctr:1337@@
 *
 * // On page:
 * $dms(1337)
 * ```
 */
export class TextBlock extends Control {
    /**
     * @hidden
     */
    protected defaultEditorElement: string = "<span />";

    /**
     * @hidden
     */
    protected dmsControlClass: string = "dms-control-textblock";

    /**
     * Internal method for setElement.
     * @param element JQueryElement for initialization.
     * @hidden
     */
    protected setElementInternal(element: JQuery): void {}

    /**
     * Get textblock text.
     * @since 4.0.0
     */
    public getValue(): string {
        return this.jQueryElement.html();
    }

    /**
     * Set textblock text.
     * @param value Text to be set.
     * @since 4.0.0
     */
    public setValue(value: string) {
        this.jQueryElement.html(value);
    }

    /**
     * Internal method for getting the template.
     * @param displayMode DisplayMode for control.
     * @param bindingField Field which the control is bound to.
     * @hidden
     */
    protected getTemplateInternal(displayMode: DisplayModes, bindingField?: string): ControlTemplate {
        let controlTemplate = new ControlTemplate();

        let element = $(this.defaultEditorElement);
        super.setDefaultEditorProperties(element);

        element.addClass(CssClass.textblock);

        if (!this.controlDefinition.Caption) {
            if (displayMode == DisplayModes.Display) {
                element.html(
                    `#= DMS.Service.TextBlock.get(data.get("${this.controlDefinition.ValueColumnName}"), "${this.textBlockCategory}") #`
                );
            } else {
                let propertyName = TEXTBLOCKCONTROL_FUNC_PROPERTY_NAME + this.controlDefinition.ControlID;
                controlTemplate.modelExtension = {
                    [propertyName]: new Function(
                        `return DMS.Service.TextBlock.get(this.get("${this.controlDefinition.ValueColumnName}", "${
                            this.textBlockCategory
                        }"))`
                    )
                };
                element.attr("data-bind", "html:" + propertyName);
            }
        } else if (this.controlDefinition.Caption) {
            element.html(this.textBlockService.get(this.controlDefinition.Caption, this.textBlockCategory));
        }

        controlTemplate.element = element;
        controlTemplate.template = element[0].outerHTML;
        controlTemplate.editable = false;
        return controlTemplate;
    }

    /**
     * Dispose the control and release all resources.
     * @since 4.0.0
     */
    public dispose(): void {
        super.dispose();
    }
}
